import {
  ClockCircleFilled,
  SafetyCertificateFilled,
  UpOutlined,
} from '@ant-design/icons';
import { Heading } from '@mm/components';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow_down.svg';
import { ReactComponent as MailIcon } from 'assets/icons/mail_new.svg';
import classNames from 'classnames';
import React, { useState } from 'react';
import css from './SmartSendingInfo.module.css';

type Props = {
  className?: string;
};

const ArrowArt = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="73" height="12" fill="none">
    <path
      fill="#9CABC1"
      /* tslint:disable-next-line:max-line-length */
      d="M1 5a1 1 0 0 0 0 2V5Zm72 1L63 .226v11.547L73 6ZM3 7a1 1 0 0 0 0-2v2Zm4-2a1 1 0 0 0 0 2V5Zm4 2a1 1 0 1 0 0-2v2Zm4-2a1 1 0 1 0 0 2V5Zm4 2a1 1 0 1 0 0-2v2Zm4-2a1 1 0 1 0 0 2V5Zm4 2a1 1 0 1 0 0-2v2Zm4-2a1 1 0 1 0 0 2V5Zm4 2a1 1 0 1 0 0-2v2Zm4-2a1 1 0 1 0 0 2V5Zm4 2a1 1 0 1 0 0-2v2Zm4-2a1 1 0 1 0 0 2V5Zm4 2a1 1 0 1 0 0-2v2Zm4-2a1 1 0 1 0 0 2V5Zm4 2a1 1 0 1 0 0-2v2Zm4-2a1 1 0 1 0 0 2V5Zm4 2a1 1 0 1 0 0-2v2Zm4-2a1 1 0 1 0 0 2V5ZM1 7h2V5H1v2Zm6 0h4V5H7v2Zm8 0h4V5h-4v2Zm8 0h4V5h-4v2Zm8 0h4V5h-4v2Zm8 0h4V5h-4v2Zm8 0h4V5h-4v2Zm8 0h4V5h-4v2Zm8 0h4V5h-4v2Z"
    />
  </svg>
);
export const SmartSendingInfo = ({ className }: Props) => {
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen(!open);

  return (
    <div
      className={classNames(className, css.container, {
        [css.open]: !!open,
      })}
    >
      <div className={css.topBar}>
        <SafetyCertificateFilled className={css.icon} />
        <span>
          In order to protect your email systems and ensure high delivery we use
          smart sending
        </span>

        <span className={css.toggleBtn} onClick={toggle}>
          <UpOutlined />
        </span>
      </div>

      <div className={css.panel}>
        <Heading size={4}>Your initial outreach email </Heading>
        <span>
          Giving your leads a chance to open your first email outreach is
          essential to keeping your deliverability score high and account
          secure.
        </span>

        <div className={css.info}>
          <span>Your initial outreach email </span>
          <span>
            Giving your leads a chance to open your first email outreach is
            essential to <strong>keeping your deliverability score high</strong>{' '}
            and account secure.
          </span>
        </div>

        <div className={css.steps}>
          <div className={css.step}>
            <div className={css.art}>
              <MailIcon />
            </div>

            <span>First Email</span>
            <span>Lead receives your first email</span>
          </div>

          <div className={css.arrow}>
            <ArrowArt />
          </div>

          <div className={css.step}>
            <div className={css.art}>
              <ClockCircleFilled color="" />
            </div>

            <span>Waiting room</span>
            <span>User engages with your email</span>
          </div>

          <div className={css.arrow}>
            <ArrowArt />
          </div>

          <div className={css.step}>
            <div className={css.art}>
              <ArrowDownIcon />
            </div>

            <span>Automation continues</span>
            <span>The rest of your automation</span>
          </div>
        </div>
      </div>
    </div>
  );
};
